import {useMemo} from "react";

export function Timestamp({time}: {time: Date | number}) {
    const timestamp = useMemo(() => {
        if (time instanceof Date) return time
        return new Date(time)
    }, [time])

    return <span>{timestamp.toLocaleDateString()} {timestamp.toLocaleTimeString()}</span>
}